class DialogCloser {
    constructor() {
      this.init();
    }
  
    init() {
        document.addEventListener('click', (event) => {
            // Trova il bottone più vicino con la classe custom-dialog-close-button
            const closeButton = event.target.closest('.custom-dialog-close-button');
            
            if (closeButton) {
            event.preventDefault();
            event.stopPropagation();

            const dialog = this.findParentDialog(closeButton);
            
            if (dialog) {
                // Aggiungi una classe di animazione per feedback visivo
                closeButton.classList.add('clicked');
                
                // Prima prova con il metodo hide()
                if (typeof dialog.hide === 'function') {
                    dialog.hide();
                } else {
                    dialog.removeAttribute('open');
                    dialog.dispatchEvent(new CustomEvent('dialog:before-hide'));
                }

                if (dialog.shadowRoot) {
                    const content = dialog.shadowRoot.querySelector('[part="content"]');
                    const overlay = dialog.shadowRoot.querySelector('[part="overlay"]');
                
                    //if (content) content.removeAttribute('style');
                    if (content) {
                        content.style.transform = 'translateX(100%)';
                        //content.style.transition = 'transform 0.3s ease-out';
                    }
                    if (overlay) overlay.removeAttribute('style');
                }

                // Rimuovi la classe dopo l'animazione
                setTimeout(() => closeButton.classList.remove('clicked'), 200);
            }
            }
        });
    }
  
    findParentDialog(element) {
      // Cerca prima il parent dialog più vicino
      let dialog = element.closest('[role="dialog"]');
      
      // Se non trova un dialog diretto, cerca nel DOM superiore
      if (!dialog) {
        dialog = element.closest('quick-buy-modal') || 
                 element.closest('x-modal') || 
                 element.closest('x-drawer') ||
                 element.closest('dialog-element');
      }
      
      return dialog;
    }
}
  
// Inizializza il closer quando il DOM è pronto
document.addEventListener('DOMContentLoaded', () => {
    new DialogCloser();
});

/*document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.custom-dialog-close-button');

    console.log('Buttons found:', buttons);
    
    buttons.forEach(button => {
        button.addEventListener('click', function() {
            console.log('Button clicked:', button);

            // Trova il drawer più vicino (genitore)
            const drawerElement = button.closest('[role="dialog"]');
            
            if (drawerElement && drawerElement.shadowRoot) {
                // Accedi alla Shadow Root
                const shadowRoot = drawerElement.shadowRoot;
                
                // Esempio: Nascondi l'overlay (se esiste)
                const overlay = shadowRoot.querySelector('[part="overlay"]');
                if (overlay) {
                    overlay.style.opacity = '0'; // Nascondi l'overlay
                }

                // Esempio: Nascondi il contenuto principale
                const content = shadowRoot.querySelector('[part="content"]');
                if (content) {
                    content.style.transform = 'translateX(-100%)'; // Slide out
                }

                // Rimuovi l'attributo `open` dal drawer stesso (se necessario)
                drawerElement.removeAttribute('open');
            } else if (drawerElement) {
                // Fallback: Se non c'è Shadow DOM, agisci direttamente
                drawerElement.style.display = 'none';
                drawerElement.removeAttribute('open');
            }
        });
    });
});
*/

